import { render, staticRenderFns } from "./SamTabs.vue?vue&type=template&id=36260e9e&scoped=true&"
import script from "./SamTabs.vue?vue&type=script&lang=js&"
export * from "./SamTabs.vue?vue&type=script&lang=js&"
import style0 from "./SamTabs.vue?vue&type=style&index=0&id=36260e9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36260e9e",
  null
  
)

export default component.exports